export enum UserSearchApiErrorTypes {
  ServiceUnavailableError,
  BadRequestError,
  NotFoundError,
}

export class UserSearchApiError {
  constructor(public type: UserSearchApiErrorTypes, public error: Error) {}
}
